import React from "react"
import { PropsWithChildren } from "react"
import { Grid } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { GridDirection, GridSpacing } from "@material-ui/core/Grid/Grid"
import clsx from "clsx"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: `${theme.spacing(5)}px 16px`,
      width: "100%",
      margin: 0,
      alignContent: "center",
      alignItems: "center",
      [theme.breakpoints.up("md")]: {
        padding: `0px 72px`,
      },
    },
    containerWrapper: {
      [theme.breakpoints.up("md")]: {
        maxWidth: 1248,
        margin: "0 auto",
      },
    },
    container: {},
  })
)

interface Props {
  divRef?: any
  spacing?: GridSpacing
  className?: string
  containerClassName?: string
  containerDirection?: GridDirection
}

export default function Section({
  divRef,
  spacing = 0,
  children,
  className,
  containerClassName,
  containerDirection,
}: PropsWithChildren<Props>) {
  const defaultClass = useStyles()

  return (
    <div ref={divRef} className={clsx(defaultClass.root, className)}>
      <div className={defaultClass.containerWrapper}>
        <Grid
          container
          spacing={spacing}
          direction={containerDirection}
          className={clsx(defaultClass.container, containerClassName)}>
          {children}
        </Grid>
      </div>
    </div>
  )
}
